module.exports = __webpack_public_path__ + "static/media/webIcons-02.985f29f9.svg";